import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getCoachUsers = createAsyncThunk(
  'access/getCoachUsers',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/coach_users`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addCoachUsers = createAsyncThunk(
  'access/addCoachUsers',
  async ({ users }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/coach_users`, {
        user_list: users,
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteCoachUser = createAsyncThunk(
  'access/deleteCoachUser',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(`/coach_users/${id}`);
      return { ...response, userId: id };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
